module.exports = __webpack_public_path__ + "static/image17-d1cc07d2d012f6802e1840000c983af3.png";